import { useModalContext } from 'src/hooks/useModalContext';
import { EventShopModalProps } from '../types';
import { MESSAGE_STATUS, useBuyItem, useMessageContext, useThrottle } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { THREE_SECONDS } from 'src/constants';

export const useBuyItemHandler = () => {
  const { closeModal, modalProps } = useModalContext<EventShopModalProps>();
  const { mutateAsync: buyShopItem } = useBuyItem({});
  const { openMessage } = useMessageContext();
  const { t } = useTranslation();

  const handleBuyItem = useThrottle(() => {
    closeModal();
    if (modalProps?.item) {
      buyShopItem({ item_id: modalProps?.item.id });
    }
  }, THREE_SECONDS);

  const handleClick = (): void => {
    openMessage?.(t('shop.successfully'), MESSAGE_STATUS.SUCCESS);
    handleBuyItem();
  };

  return { handleClick };
};
